// Day 21 — the AUTO-renew email for a policy paying by monthly Direct Debit.
// Same layout as A21; the copy and the card speak to the PremFina agreement
// instead of a collection schedule. No pricing, no SMS.

import type { EmailData } from "../../types";
import { longDate } from "../../format";
import { b, body, call, esc, p } from "../../layouts/chrome";
import { genericEmailHtml } from "../../layouts/generic";
import { brand } from "../brand";

export const subject = ({ renewalDate }: EmailData) =>
  `Your ${brand.name} policy will renew automatically on ${longDate(renewalDate)}`;

export const html = (data: EmailData) =>
  genericEmailHtml({
    brand,
    data,
    callNumber: brand.callNumber,
    noActionText: "Your renewal is all set — your cover will continue automatically.",
    notRenewingTail:
      "before your renewal date so we can update your policy and payment arrangements.",
    detail: {
      title: "Your Direct Debit",
      rows: [
        ["Payment method", "PremFina Direct Debit"],
        ["Policy renewal date", longDate(data.renewalDate)],
        ["First Direct Debit payment", "Within 7 days of your renewal date"],
        ["Future payments", "Collected monthly in line with your PremFina finance agreement"],
      ],
    },
    bodyHtml: body(
      p(
        `Good news — there's nothing you need to do. Your policy for ${b(`'${esc(data.companyName)}'`)} will ${b(`automatically renew on ${longDate(data.renewalDate)}`)}, so your cover will continue without interruption.`,
      ),
      p(
        `Your renewal documents will be available in your ${b("My Portal")} account once your policy has renewed.`,
      ),
      p(
        `Your Direct Debit is provided through ${b("PremFina")}. Your first payment will be collected ${b("within 7 days of your renewal date")}, with future payments collected in line with your finance agreement.`,
      ),
      p(
        `You only need to get in touch if you do ${b("not")} want your policy to renew. If that's the case, please call our UK-based team on ${call(brand)} before your renewal date and we'll be happy to help.`,
      ),
    ),
  });
